<div [formGroup]="group" class="main {{ userClass }}">
  <div
    [class.haserror-gotop]="isshow && f[name].touched && f[name]?.invalid"
    [class.gotop]="isshow"
    (focus)="focusFunction()"
    (click)="focusFunction(); inp.click()"
    (focusout)="focusOutFunction()"
    class="label">
    <label class="txt" [class.lbl]="isshow" [class.error]="f[name].touched && f[name]?.invalid">
      {{ "ClientApp.Projects.FrameWorkShell.Shared.Controls.SepidzColorPicker.ColorSelection" | translate }}</label
    >
    <span class="star" [class.error]="f[name].touched && f[name]?.invalid" *ngIf="required === true"> * </span>
  </div>
  <div class="inputbox">
    <input
      #inp
      type="text"
      (focus)="focusFunction()"
      (focusout)="focusOutFunction()"
      [class.hasborder]="isshow"
      [class.border]="isshow"
      [formControl]="formControl()"
      [class.bordererror]="f[name].touched && f[name]?.invalid"
      autocomplete="falsedss"
      class="textinput"
      id="{{ name }}"
      name="{{ name }}"
      [style.background]="Currentvalue"
      [colorPicker]="Currentvalue"
      [cpCancelButton]="true"
      [cpToggle]="cpToggle"
      (colorPickerChange)="onChange($event)" />
    <div class="error unvisible" *ngIf="f[name].touched && f[name]?.invalid" [class.visible]="f[name].touched && f[name]?.invalid">
      <span *ngIf="f[name].errors?.required"> {{ label }} {{ "Errors.Required" | translate }} </span>
      <span [hidden]="!f[name].errors?.pattern"> {{ label }} {{ "Errors.Pattern" | translate }} </span>
      <span [hidden]="!f[name].errors?.minlength">
        {{ ("Errors.Minlength" | translate).replace("[0]", label).replace("[1]", minLength) }}
      </span>
      <span [hidden]="!f[name].errors?.maxlength">
        {{ ("Errors.Maxlength" | translate).replace("[0]", label).replace("[1]", maxLength) }}
      </span>
      <span [hidden]="!f[name].errors?.max">
        {{ ("Errors.Length" | translate).replace("[0]", label).replace("[1]", min).replace("[2]", max) }}
      </span>
    </div>
  </div>
</div>
